import { Image, StyleSheet, Text, View } from 'react-native'
import React, { memo, useCallback } from 'react'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon
} from 'react-share'
import { IconButton as IconPress } from '../ANewDesign/IconButton'
import { IconButton } from 'react-native-paper'
import { BottomSheetView } from '@gorhom/bottom-sheet'
import { useShareSheet } from './useShareSheet'
import { observer } from 'mobx-react-lite'
import * as Clipboard from 'expo-clipboard'

import { useStore } from '../../models'
import { useToastStore } from '../../navigation/toast'
import { DS } from '../../design-system'

const ICON_SIZE = 32

export const ShareSheetContent = observer(() => {
  const { close: closeShareSheetModal } = useShareSheet()

  const shareInfo = useStore().share.info
  const title = shareInfo?.message ?? 'Join my game on Poker Power'
  const shareUrl = shareInfo?.url ?? 'https://app.pokerpower.com/'

  const onCopyToClipboard = useCallback(async () => {
    const copyText = `${title} - ${shareUrl}`
    await Clipboard.setStringAsync(copyText)
    closeShareSheetModal()
    useToastStore.getState().enqueueToast({
      kind: 'success',
      message: `Copied to your clipboard:\n\n ${title} \n ${shareUrl}`
    })
  }, [closeShareSheetModal, title, shareUrl])

  return (
    <BottomSheetView>
      <DS.Frame style={styles.container}>
        <DS.Frame style={styles.header}>
          <DS.Frame style={styles.title}>
            <DS.Frame style={styles.titleIcon}>
              <Image
                source={require('../../assets/logo-app.png')}
                style={{ width: 32, height: 32, borderRadius: 32 }}
              />
            </DS.Frame>
            <DS.Frame flex={1}>
              <DS.Text variant="Heading 5/Regular">{title}</DS.Text>
              <DS.Text
                variant="Body Small/Medium"
                color="Brand/Dark Grey"
                style={{
                  marginTop: 8
                }}
              >
                {shareUrl}
              </DS.Text>
            </DS.Frame>
          </DS.Frame>

          <IconPress onPress={() => closeShareSheetModal()}>
            <IconButton icon={'close'} iconColor="black" />
          </IconPress>
        </DS.Frame>

        <SocialIcons title={title} shareUrl={shareUrl} />

        <IconPress onPress={onCopyToClipboard}>
          <View style={styles.copy}>
            <Text>Copy</Text>
            <IconButton icon="content-copy" iconColor="black" />
          </View>
        </IconPress>
      </DS.Frame>
    </BottomSheetView>
  )
})

const SocialIcons = memo(({ title, shareUrl }: { title: string; shareUrl: string }) => {
  return (
    <DS.Frame row style={styles.socialIconsContainer}>
      <View style={styles.iconContainer}>
        <WhatsappShareButton title={title} separator=" " url={shareUrl}>
          <WhatsappIcon size={ICON_SIZE} round />
        </WhatsappShareButton>
      </View>

      <View style={styles.iconContainer}>
        <FacebookShareButton url={shareUrl}>
          <FacebookIcon size={ICON_SIZE} round />
        </FacebookShareButton>
      </View>

      <View style={styles.iconContainer}>
        <TwitterShareButton url={shareUrl} title={title}>
          <XIcon size={ICON_SIZE} round />
        </TwitterShareButton>
      </View>

      <View style={styles.iconContainer}>
        <TelegramShareButton url={shareUrl} title={title}>
          <TelegramIcon size={ICON_SIZE} round />
        </TelegramShareButton>
      </View>
      <View style={styles.iconContainer}>
        <EmailShareButton url={shareUrl} subject={title} body="body">
          <EmailIcon size={ICON_SIZE} round />
        </EmailShareButton>
      </View>

      <View style={styles.iconContainer}>
        <FacebookMessengerShareButton url={shareUrl} appId="521270401588372">
          <FacebookMessengerIcon size={ICON_SIZE} round />
        </FacebookMessengerShareButton>
      </View>

      <View style={styles.iconContainer}>
        <LinkedinShareButton url={shareUrl}>
          <LinkedinIcon size={ICON_SIZE} round />
        </LinkedinShareButton>
      </View>

      <View style={styles.iconContainer}>
        <RedditShareButton url={shareUrl} title={title} windowWidth={660} windowHeight={460}>
          <RedditIcon size={ICON_SIZE} round />
        </RedditShareButton>
      </View>
    </DS.Frame>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 24,
    marginBottom: 48
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 16
  },
  divider: {
    height: 1,
    backgroundColor: 'grey'
  },
  title: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16
  },
  titleIcon: {
    alignSelf: 'flex-start'
  },
  socialIconsContainer: {
    justifyContent: 'space-evenly'
  },
  copy: {
    marginTop: 16,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fffffa',
    borderRadius: 6,
    shadowColor: '#0000001A',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 1,
    shadowRadius: 5
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    borderRadius: 8
  }
})
